import { ServiceMaker, methods, services } from "@/services";
import Api from "@/services/service-v2";

export const listOrderForTenant = (data) =>
  ServiceMaker(
    `/api/v1/order/listbytenant/${data.id}?n=${data.count}&isMaster=true${
      data.orderStatus ? "&orderStatus=" + data.orderStatus : ""
    }`,
    methods.GET,
    services.order
  );

export const listOrderForSeller = (count) =>
  ServiceMaker(
    `/api/v1/get/listbyseller/status/all?n=${count}&isMaster=true`,
    methods.GET,
    services.order
  );

export const getOrderDetails = (payload) =>
  Api().$http
    .get(`/orders/api/v3/seller/orders/${payload}`)
    .then((response) => response.data);

export const listOrderForAllUsers = (payload) => {
  const page = payload.page || 1;
  const limit = payload.limit || 10;
  const isTenantUser = payload.userCategory === "TA";
  const status =
    typeof payload.status === "string" && payload.status.trim().length > 0
      ? payload.status.trim()
      : "";

  let orderUrl = `/orders/api/v3/seller/orders?page=${page}&limit=${limit}`;

  if (isTenantUser) {
    orderUrl = `/orders/api/v3/orders?page=${page}&limit=${limit}`;
  }

  if (status) {
    orderUrl = `${orderUrl}&status=${encodeURIComponent(status)}`;
  }

  return Api().$http.get(orderUrl).then((response) => response.data);
};

export const listOrderForManufacturer = (count) =>
  ServiceMaker(
    `/api/v1/get/listbymanufacturer?n=${count}&isMaster=true`,
    methods.GET,
    services.order
  );

export const updatePickupTime = (data) =>
  ServiceMaker(`/api/v1/updates`, methods.POST, services.order, data);

export const getPartner30daysorderscount = () =>
  ServiceMaker(`/stats/partnerMonthlyOrders`, methods.GET, services.order);

export const getTenant30daysorderscount = (Id) =>
  ServiceMaker(`stats/tenantMonthlyOrders/${Id}`, methods.GET, services.order);

export const getPartnerSalesGroup = () =>
  ServiceMaker(`stats/partnerSales`, methods.GET, services.order);

export const getTenantSalesGroup = (Id) =>
  ServiceMaker(`stats/tenantSales/${Id}`, methods.GET, services.order);

export const getInvoiceData = (orderId) =>
  ServiceMaker(`packaging/invoice/${orderId}`, methods.GET, services.order);

export const getTotalDeliveryCost = () =>
  ServiceMaker(`stats/total-delivery-cost`, methods.GET, services.order);

export const getCheckoutHistory = (payload) =>
  ServiceMaker(
    `checkout/history-list`,
    methods.POST,
    services.checkout,
    payload
  );

export const setDeliveryAgent = (payload) =>
  Api().$http.post(`order/api/v1/updates/set-delivery-agent`, payload);

export const updateShippingOrder = (orderId, payload) => {
  return Api().$http.post(
    `order/api/v2/sales-order/update-shipping-order/${orderId}`,
    payload
  );
};
